const RELEASE_MODE = false;

const Config = {
    RELEASE_MODE
};
  
export default Config;